import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=5feb5116&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feb5116",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5feb5116')) {
      api.createRecord('5feb5116', component.options)
    } else {
      api.reload('5feb5116', component.options)
    }
    module.hot.accept("./loading.vue?vue&type=template&id=5feb5116&scoped=true", function () {
      api.rerender('5feb5116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/loading.vue"
export default component.exports